// plugins/auth.ts
import {createAuthClient} from 'better-auth/vue'
import {authClient} from '~/lib/auth-client'
import {magicLinkClient, emailOTPClient, organizationClient} from 'better-auth/client/plugins'

// 1. Create a reference type so TypeScript can read the plugin methods
const clientTypeRef = createAuthClient({
  plugins: [magicLinkClient(), emailOTPClient()]
})
type AuthClientType = typeof clientTypeRef

export default defineNuxtPlugin(() => {
  const config = useRuntimeConfig()

  const authClient = createAuthClient({
    baseURL: config.public.authBaseUrl,
    fetchOptions: {
      credentials: 'include'
    },
    trustedOrigins: ['https://insights.oldhobo.com', 'http://insights.oldhobo.com', 'http://localhost:3000'],
    plugins: [magicLinkClient(), emailOTPClient(), organizationClient()]
  })

  return {
    provide: {
      auth: authClient
    }
  }
})
